// src/tattoo/guestIdentity.js

const GUEST_ID_KEY = "tt_guest_id_v1";
const GUEST_NAME_KEY = "tt_guest_name_v1";

/** Stable per-browser guest id (for likes, uploads, etc.) */
export function getGuestId() {
  try {
    let id = localStorage.getItem(GUEST_ID_KEY);
    if (!id) {
      id = "guest_" + Math.random().toString(36).slice(2);
      localStorage.setItem(GUEST_ID_KEY, id);
    }
    return id;
  } catch {
    // SSR / locked storage: still return something
    return "guest_" + Math.random().toString(36).slice(2);
  }
}

/** Read the stored guest display name (for comments) */
export function getStoredGuestName() {
  try {
    return localStorage.getItem(GUEST_NAME_KEY) || "";
  } catch {
    return "";
  }
}

/** Save guest display name */
export function setStoredGuestName(name) {
  try {
    if (!name) {
      localStorage.removeItem(GUEST_NAME_KEY);
    } else {
      localStorage.setItem(GUEST_NAME_KEY, String(name).slice(0, 64));
    }
  } catch {
    // ignore
  }
}